module.exports = {
    postMapper: require('./post/mapper'),
    categoryMapper: require('./category/mapper'),
};
//# sourceMappingURL=index.js.map